<aside>
  <div class="other-project-link">
    <a [routerLink]="'/developments/' + development.id" class="nav-link link-decoration">
      Other Projects<i class="chevron-double-right"></i>
    </a>
  </div>
</aside>
<aside class="card card-padding">
  <div class="row project-detail-card-row print-border">
    <div class="col-lg-8 project-detail-card">
      <div class="development-info">
        <h4 class="skiptranslate">
          {{
            isMultiDevelopment
              ? multiDevelopmentTitle
              : (development.name | titleCasewithAvoidWords)
          }}
        </h4>
        <div class="row">
          <div style="width: 25px" class="location-image">
            <img
              src="assets/img/icons/location-sm.svg"
              width="15"
              height="22"
              class="d-none d-md-block"
              alt="..."
            />
          </div>
          <div class="development-sub-title skiptranslate" style="width: 95%">
            {{
              isMultiDevelopment
                ? multiDevelopmentLocationTitle
                : (development.address | titleCasewithAvoidWords)
            }}
          </div>
        </div>
      </div>
      <div class="project-status-code">
        <h4>{{ (project !== undefined ? project.name : "") | titleCasewithAvoidWords | simplifyWords }}</h4>
        <div>
          <div *ngFor="let status of projectStatus" class="project-category">{{ status }}</div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 project-detail-card project-card-image">
      <div class="project-img-bg" *ngIf="project !== undefined">
        <app-carousel
          [project]="_project"
          [notCardImage]="true"
          [BgColor]="'#FFFFFF'"
        ></app-carousel>
        <!-- <img src="/assets/img/bg/project-steam.png" alt="" class="card-img-top" alt="..." /> -->
      </div>
    </div>
  </div>
</aside>
<aside class="card">
  <div class="row project-detail-card-row">
    <div class="col-lg-6 project-detail-card print-border">
      <div class="project-scope-bg">
        <div class="scope-title-parent">
          <div class="col-lg-9 project-scope-title">Project Scope</div>
          <div class="col-lg-3" style="height: 60px">
            <img
              src="assets/img/icons/project-scope-lg.svg"
              width="60"
              height="60"
              class="d-none d-md-block"
              alt="..."
            />
          </div>
        </div>
        <div class="scopeofwork">
          {{ isPlannedProject ? plannedProjectText : project.scopeOfWork }}
        </div>
      </div>
    </div>
    <div class="col-lg-6 project-detail-card project-update-card print-border-bottom">
      <div class="project-update-bg">
        <div class="scope-title-parent">
          <div class="col-lg-9 project-scope-title">Project Update (Biweekly)</div>
          <div class="col-lg-3">
            <img
              src="assets/img/icons/project-update-lg.svg"
              width="60"
              height="60"
              class="d-none d-md-block"
              alt="..."
            />
          </div>
        </div>
        <div class="scopeofwork">
          {{ isPlannedProject ? plannedScopeText : project.projectUpdate }}
        </div>
      </div>
    </div>
  </div>
</aside>
<aside class="card">
  <div class="page-break-print">
    <div class="project-progress">
      <h4>
        Project Progress<br />(Delivery Type: {{ (project !== undefined ? project.deliveryType : "") | titleCasewithAvoidWords }})
      </h4>
    </div>
    <div class="row project-planning-row">
      <div class="col-lg-3 project-planning-col" *ngFor="let item of project?.schedule">
        <div class="pp-shadow">
          <div class="title-percent-container">
            <div class="pp-title">{{ item.masterTaskName | titleCasewithAvoidWords }}</div>
            <div class="pp-percent">{{ item.percentageCompleted }}%</div>
          </div>
          <div class="bg-gray-percent">
            <div
              class="bg-teal-percent"
              [ngStyle]="{ width: item.percentageCompleted + '%' }"
            ></div>
          </div>

          <div class="date-planning-rows">
            <div class="row date-planning-row">
              <div class="col-lg-7 pp-date-heading">Planned Start Date</div>
              <div class="col-lg-5 pp-date">{{ item.baselineStartDate | safeDate }}</div>
            </div>

            <!-- <div class="row date-planning-row">
              <div class="col-lg-7 pp-date-heading">Actual Start Date</div>
              <div class="col-lg-5 pp-date">{{ item.actualStartDate | safeDate }}</div>
            </div> -->

            <div class="row date-planning-row">
              <div class="col-lg-7 pp-date-heading">
                {{
                  !isCompletedProject &&
                  (item.actualStartDate.toLocaleLowerCase() === "invalid date" ||
                    item.actualStartDate.toLocaleLowerCase() === "to be determined")
                    ? "Current Estimated Start Date"
                    : "Actual Start Date"
                }}
              </div>
              <div class="col-lg-5 pp-date">
                {{
                  (!isCompletedProject &&
                  (item.actualStartDate.toLocaleLowerCase() === "invalid date" ||
                    item.actualStartDate.toLocaleLowerCase() === "to be determined")
                    ? item.startDate
                    : item.actualStartDate
                  ) | safeDate
                }}
              </div>
            </div>

            <div class="row date-planning-row">
              <div class="col-lg-7 pp-date-heading">Planned End Date</div>
              <div class="col-lg-5 pp-date">{{ item.baselineFinishDate | safeDate }}</div>
            </div>

            <div class="row date-planning-row">
              <div class="col-lg-7 pp-date-heading">
                {{
                  !isCompletedProject &&
                  (item.actualFinishDate.toLocaleLowerCase() === "invalid date" ||
                    item.actualFinishDate.toLocaleLowerCase() === "to be determined")
                    ? "Current Estimated End Date"
                    : "Actual End Date"
                }}
              </div>
              <div class="col-lg-5 pp-date">
                {{
                  (!isCompletedProject &&
                  (item.actualFinishDate.toLocaleLowerCase() === "invalid date" ||
                    item.actualFinishDate.toLocaleLowerCase() === "to be determined")
                    ? item.finishDate
                    : item.actualFinishDate
                  ) | safeDate
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</aside>
